module.exports = __webpack_public_path__ + "img/impressum.e450f150.jpg";